import { FormArray, FormControl } from '@angular/forms';
import { validate, ValidationTypes } from 'class-validator';
import { from, map, of } from 'rxjs';
import { ValidationKeys } from '../models';
import { DynamicFormGroup } from '../dynamic-form/dynamic-form-group';
/**
* Recursively creates an empty object from the data provided
*/
export var ValidationUtils;
(function (ValidationUtils) {
  function transformValidationErrors(errors) {
    const customErrors = {};
    errors.forEach(error => {
      if (error && error.constraints !== undefined) {
        Object.keys(error.constraints).forEach(key => {
          if (!customErrors[error.property]) {
            customErrors[error.property] = [];
          }
          if (customErrors[error.property].indexOf(error.constraints[key]) === -1) {
            customErrors[error.property].push(error.constraints[key]);
          }
        });
      }
      if (error.children !== undefined && error.children.length) {
        customErrors[error.property] = transformValidationErrors(error.children);
      }
    });
    return customErrors;
  }
  ValidationUtils.transformValidationErrors = transformValidationErrors;
  function markAsInvalidForExternalErrors(errors, controls) {
    Object.keys(controls).forEach(field => {
      const control = controls[field];
      // Control
      if (control instanceof FormControl) {
        if (errors && errors[field]) {
          control.setErrors({
            externalError: true
          });
        } else {
          if (control.errors && control.errors.externalError === true) {
            control.setErrors(null);
          }
        }
      }
      // Group
      else if (control instanceof DynamicFormGroup) {
        markAsInvalidForExternalErrors(errors && errors[field] ? errors[field] : {}, control.controls);
      }
      // Array
      else if (control instanceof FormArray) {
        for (let i = 0; i < control.length; i++) {
          // Control in Array
          if (control[i] instanceof FormControl) {
            if (errors && errors[i] && errors[i][field]) {
              control[i].setErrors({
                externalError: true
              });
            } else if (control[i].errors && control[i].errors.externalError === true) {
              control[i].setErrors(null);
            }
          }
          // Group in Array
          else if (control[i] instanceof DynamicFormGroup) {
            markAsInvalidForExternalErrors(errors && errors[i] && errors[i][field] ? errors[i][field] : {}, control[i].controls);
          }
        }
      }
    });
  }
  ValidationUtils.markAsInvalidForExternalErrors = markAsInvalidForExternalErrors;
  // Global Helper functions
  function isPropertyValidatorOfType(validationMetadata, fieldName, validationMetadataType) {
    return validationMetadata.propertyName === fieldName && validationMetadata.type === validationMetadataType;
  }
  ValidationUtils.isPropertyValidatorOfType = isPropertyValidatorOfType;
  function setObjectValueAndGetValidationErrors(fieldName, control, validatorOptions) {
    const object = control.parent instanceof DynamicFormGroup ? control.parent.getObject() : control.parent ? control.parent.value : {};
    if (object) {
      object[fieldName] = control.value;
    }
    return getValidateErrors(fieldName, control, object, validatorOptions);
  }
  ValidationUtils.setObjectValueAndGetValidationErrors = setObjectValueAndGetValidationErrors;
  function getValidateErrors(fieldName, control, dataToValidate, validatorOptions) {
    if (!dataToValidate) throw new Error('Invalid dataToValidate passed to getValidateErrors()!');
    /* TODO: the way class-validator works requires executing validation against whole parent model.
        This is inefficient and can be improved by implementing a validation results cache per formgroup.
     return (control?.root?.valueChanges || control?.parent?.valueChanges || control?.valueChanges || of({})).pipe(
    flatMap(() => (control.parent && control.parent.value ? from(validate(dataToValidate, validatorOptions)) : of([]))),
    map(errors => transformValidationErrors(errors))
    );
    // or
    return of({}).pipe(
    flatMap(() =>
    control.parent && control.parent.value && control.parent instanceof DynamicFormGroup
    ? control.parent.customValidateErrors
    : of({})
    )
    );*/
    return (control.parent && control.parent.value ? from(validate(dataToValidate, validatorOptions)) : of([])).pipe(map(errors => transformValidationErrors(errors)));
  }
  ValidationUtils.getValidateErrors = getValidateErrors;
  function getIsValidResult(isValid, validationMetadata, errorType) {
    return isValid ? null : {
      [errorType]: {
        valid: false,
        type: validationMetadata.type
      }
    };
  }
  ValidationUtils.getIsValidResult = getIsValidResult;
  /**
   * "standard" Validations - everything that is neither a custom nor a nested Validation
   */
  function isDynamicValidate(validationMetadata, typeKey, validator) {
    return validationMetadata.type === ValidationTypes[typeKey] && validator[validationMetadata.type] !== undefined;
  }
  ValidationUtils.isDynamicValidate = isDynamicValidate;
  /**
  * marked with @Validate(...)
  * https://github.com/typestack/class-validator#custom-validation-classes
  */
  function isCustomValidate(validationMetadata, typeKey, validator) {
    return typeKey === ValidationKeys.custom.typeKey && validationMetadata.type === ValidationKeys.custom.type && validator[validationMetadata.type] === undefined;
  }
  ValidationUtils.isCustomValidate = isCustomValidate;
  /**
  * marked with @ValidateNested()
  * https://github.com/typestack/class-validator#validating-nested-objects
  */
  function isNestedValidate(validationMetadata, typeKey, validator) {
    return typeKey === ValidationKeys.nested.typeKey && validationMetadata.type === ValidationKeys.nested.type && validator[validationMetadata.type] === undefined;
  }
  ValidationUtils.isNestedValidate = isNestedValidate;
})(ValidationUtils || (ValidationUtils = {}));